export default __webpack_public_path__ + "static/polo-59c39e7d08820abaf395c078fd8751aa.png";